import { useState } from 'react'
import { api } from '../api'

/**
 * Propose that a limit stops applying — decision 72.
 *
 * The limit binds as before until an approver who did not propose this agrees, on
 * Awaiting approval. Nothing is deleted then either: its period closes on the day
 * given, and it stays the right answer for every day it applied.
 */
export function RetireLimit({
  ruleId,
  what,
  onDone,
  onCancel,
}: {
  ruleId: string
  /** How the limit is named in the confirmation, such as its key or the group's name. */
  what: string
  onDone: (message: string) => void
  onCancel: () => void
}) {
  const [endsOn, setEndsOn] = useState(() => new Date().toISOString().slice(0, 10))
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit() {
    setBusy(true)
    setError(null)
    try {
      await api.proposeRetirement(ruleId, endsOn, reason.trim())
      onDone(`Retiring ${what} from ${endsOn} is proposed. It stays in force until an approver agrees.`)
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="retire-form" data-testid="retire-form">
      {error && (
        <p className="error" role="alert">
          {error}
        </p>
      )}
      <div className="row-form">
        <label>
          No longer applies from
          <input type="date" value={endsOn} onChange={(e) => setEndsOn(e.target.value)} />
        </label>
        <label className="wide">
          Why
          <input
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Client's letter of 12 September removes it"
          />
        </label>
        <button disabled={busy || !endsOn || !reason.trim()} onClick={() => void submit()}>
          Propose to retire
        </button>
        <button className="ghost" disabled={busy} onClick={onCancel}>
          Cancel
        </button>
      </div>
      <p className="note">
        It stays in force until an approver who did not propose it agrees, on Awaiting approval.
      </p>
    </div>
  )
}
